import React, { useRef, useState } from "react";
import { Form, Formik, FormikHelpers } from "formik";
import * as Yup from "yup";
import { PersonalInfo, PersonalInfoFormFields } from "../models/user-interface";
import { ERRORS } from "../../constants/user-info.const";
import PersonalInfoForm from "../user-forms/PersonalInfoForm";
import UiModal from "../../common/ui/UiModal";
import Loader from "../../common/Loader";
import { formSubmitErrorHandler } from "../../../services/formService";
import { updateEmployee } from "../../../services/employeeService";
import { formatDateYYMMDD, getDateWithTimeZone } from "../../../utils/dateUtil";

interface ModalProps {
  open: boolean;
  handleClose: (result?: any, action?: any) => void;
  personalInfo: PersonalInfo | undefined;
  personalInfoUpdateCallback: (result?: any) => void;
}

export default function PersonalInfoEditModal(props: ModalProps) {
  const { open, handleClose, personalInfo, personalInfoUpdateCallback } = props;
  const title = "Edit Personal Information";
  const formRef: any = useRef();
  const [isShowFooterLoader, setIsShowFooterLoader] = useState<boolean>(false);

  const onSubmit = (
    {
      first_name,
      middle_initial,
      last_name,
      email,
      date_of_birth,
      ssn,
    }: PersonalInfoFormFields,
    formHelpers: FormikHelpers<any>
  ) => {
    const data = {
      version: personalInfo?.version,
      first_name: first_name,
      middle_initial: middle_initial,
      last_name: last_name,
      email: email,
      date_of_birth: date_of_birth,
      two_percent_shareholder: personalInfo?.two_percent_shareholder,
    };
    if (ssn) {
      data["ssn"] = ssn;
    }
    if (date_of_birth) {
      data["date_of_birth"] = formatDateYYMMDD(date_of_birth);
    }
    setIsShowFooterLoader(true);
    formSubmitErrorHandler(
      updateEmployee(data).then((res: any) => {
        setIsShowFooterLoader(false);
        personalInfoUpdateCallback(res?.data);
      }),
      () => {
        setIsShowFooterLoader(false);
      },
      formHelpers.setFieldError
    );
  };
  const validationSchema = Yup.object({
    first_name: Yup.string().required(ERRORS.firstName),
    last_name: Yup.string().required(ERRORS.lastName),
    email: Yup.string()
      .email(ERRORS.validEmail)
      .max(255)
      .required(ERRORS.email),
    date_of_birth: Yup.date()
      .required(ERRORS.dob)
      .nullable()
      .default(undefined),
    ssn: Yup.number().required(ERRORS.ssn),
  });
  return (
    <UiModal
      open={open}
      handleClose={handleClose}
      title={title}
      handleSave={() => {
        formRef.current?.handleSubmit();
      }}
      showFooterLoader={isShowFooterLoader}
    >
      <Formik
        initialValues={{
          first_name: personalInfo?.first_name ?? "",
          middle_initial: personalInfo?.middle_initial ?? "",
          last_name: personalInfo?.last_name ?? "",
          email: personalInfo?.email ?? "",
          date_of_birth: personalInfo?.date_of_birth
            ? getDateWithTimeZone(personalInfo?.date_of_birth)
            : null,
          ssn: "",
        }}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        enableReinitialize
        validateOnMount={false}
        innerRef={formRef}
      >
        {() => {
          return (
            <Form>
              <PersonalInfoForm />
            </Form>
          );
        }}
      </Formik>
    </UiModal>
  );
}
